import { render, staticRenderFns } from "./Timespan.vue?vue&type=template&id=90095922"
import script from "./Timespan.vue?vue&type=script&lang=js"
export * from "./Timespan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports